import { useRef, useEffect } from 'react';

interface SearchBoxProps {
  onSearch?: (query: string) => void;
}

export default function SearchBox({ onSearch }: SearchBoxProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === '/' && document.activeElement !== inputRef.current && document.activeElement?.tagName !== 'INPUT' && document.activeElement?.tagName !== 'TEXTAREA') {
        e.preventDefault();
        inputRef.current?.focus();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const value = inputRef.current?.value.trim();
    if (value && onSearch) {
      onSearch(value);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-2xl mx-auto">
      <div className="relative">
        <i className="ri-search-line absolute left-5 top-1/2 -translate-y-1/2 text-foreground-400 text-xl"></i>
        <input
          ref={inputRef}
          type="text"
          placeholder="搜索网站、工具、资源... 按 / 快速聚焦"
          className="w-full pl-14 pr-28 py-4 text-base rounded-full border-2 border-background-200 bg-background-50 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:ring-4 focus:ring-primary-100 focus:border-primary-400 transition-all"
        />
        <button
          type="submit"
          className="absolute right-2 top-1/2 -translate-y-1/2 px-5 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-full transition-colors cursor-pointer whitespace-nowrap"
        >
          搜索
        </button>
      </div>
      <div className="flex items-center justify-center gap-4 mt-4 flex-wrap">
        <span className="text-xs text-foreground-400">热门搜索：</span>
        {['百度', 'B站', '淘宝', '知乎', '抖音', 'GitHub'].map((item) => (
          <button
            key={item}
            type="button"
            onClick={() => {
              if (inputRef.current) inputRef.current.value = item;
              if (onSearch) onSearch(item);
            }}
            className="text-xs text-foreground-500 hover:text-primary-600 hover:bg-primary-50 px-2.5 py-1 rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            {item}
          </button>
        ))}
      </div>
    </form>
  );
}